<template>
  <div id="app">
      <!-- HEADER -->
        <!-- HEADER ANIONE -->
      <div class="header">
        <router-link to="/">
          <h1 class="website_name"><span class="website_name_span first" style="color:white;">Ani</span><span class="website_name_span" style="color:#0d6efd">One</span></h1>
        </router-link>
      </div>
        <!-- HEADER ANIONE END -->
    
    <div v-show="inUpButton === 0">
        <div class="signout" @click="signout()">Выход</div>
    </div>
    <div v-show="inUpButton === 1">
      <router-link class="signin_link" to="/cabinet/favorite">
        <div class="cabinet"><img style="width: 26px; position: absolute; top: -2px; right: -10px;" src="@/assets/icons/account.svg"></div>
      </router-link>
    </div>
    <div v-show="inUpButton === 2">
      <router-link class="signin_link" to="/auth">
        <div class="signin">Вход</div>
      </router-link>
    </div>
    <!-- HEADER END -->
    
    <router-view></router-view>
  </div>
</template>

<script>


export default {
  name: 'App',
  data(){
    return {
      inUpButton: 1
    }
  },
  mounted(){
    // this.getLocalStorage()
    //Вставляем никнейм пользователя в угол страницы, если этот пользователь сейчас залогинен
    if(localStorage.getItem('username')){
      document.querySelector('.cabinet').insertAdjacentHTML('afterbegin', `<span class="username_header" style="margin-right: 20px;">${localStorage.getItem('username')}</span>`);
    }
  },
  watch:{
    $route (to, from){
      if(!to.path.startsWith("/cabinet")){
        if(!localStorage.getItem('password_hash')){
          this.inUpButton = 2;
        }else{
          this.inUpButton = 1;
        } 
      }else if(to.path.startsWith("/cabinet")){
        this.inUpButton = 0;
      }
    }
  },
  methods:{
    signout: function(){
      //Прыгаем на главную страницу
      window.location.pathname = '/';
      //Удаляем все данные из local storage, чтобы разлогиниться
      localStorage.removeItem('user_id');
      localStorage.removeItem('password_hash');
      localStorage.removeItem('username');
    }
  }
};


</script>




<style>
@font-face {
  font-family: 'Asher Punk';
  src: url('~@/assets/fonts/asherpunk.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}

@import url("https://fonts.googleapis.com/css2?family=Exo+2&display=swap");
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@700;800&display=swap');

@media only screen and (max-width: 768px) {
  .username_header{
    display: none;
  }
}


html, body{
  background: #00060e;
  color: white;
  margin: 0;
  padding: 0;
}

#carousel .item{
  font-family: 'Montserrat', sans-serif;
}

.website_name{
  width: 100px;
  display: inline-block;
  font-family: 'Asher Punk', sans-serif;
  position: relative ;
  z-index: 5;
}

.header{
  text-align: center;
}

#app .signin, .signout, .cabinet{
  position: absolute;
  right: 34px;
  top: 32px;
  z-index: 10;
  font-family: 'Montserrat';
  cursor: pointer;
}

a{
  color: white;
  text-decoration: none;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

#app {
  margin: 0 auto;
  line-height: 1.4;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: $vue-blue;
}

h1 {
  text-align: center;
}
</style>